<template>
    <div>
        <app-select
            :placeholder="placeholder"
            :name="name"
            :id="name"
            :is-multiple="isMultiple"
            :use-search="useSearch"
            :options="options"
            v-model="value"
            @input="onChange"
            @submit="onSubmit"
        ></app-select>
    </div>
</template>

<script>
    import Url from "../tools/url";

    export default {
        props: {
            placeholder: String,
            name: String,
            options: Array,
            fieldValue: String|Array,
            isMultiple: {
                type: Boolean,
                default: false
            },
            useSearch: {
                type: Boolean,
                default: false
            },
        },

        data() {
            return {
                value: this.fieldValue
            };
        },

        methods: {
            onChange() {
                if (!this.isMultiple) {
                    this.onSubmit();
                }
            },
            onSubmit() {
                let url = new Url(document.location.href);
                url.setQueryParameter(this.name, this.value);
                url.removeQueryParameter("page");
                document.location.href = url.buildUrl();
            }
        }
    }
</script>

